commusoftCommon.directive('smarttablecontainer', ['$rootScope', 'prefix', '$http', 'tableCollection', function($rootScope, prefix, $http, tableCollection) {
    return {
        restrict: 'ACE',
        link: function($scope, elem, attrs) {
            $scope.category = attrs.category;
            tableCollection.setData($scope.category, {'data': [], 'active_columns': []});
        }
    }
}]);
